<template>
  <section class="standard-box">
    <FloatingActionButtons
      :box="box"
      :index="index"
      :computedBoxesData="boxes"
      :activeFABIndex="activeFABIndex"
      @passActiveIndex="$emit('passActiveIndex', $event)"
      @editVisibility="editVisibility"
      @showDeleteModal="showDeleteModal"
      @showEditModal="showEditModal"
      @showVisibilityModal="showVisibilityModal"
    />
    <div
      class="column"
      :class="{ removeTopPadding: !box.showIconImage && !box.showBgImage, extraTopPadding: box.showBgImage }"
      :style="{
        backgroundColor: box.showBgImage ? 'initial' : box.boxColor,
        color: box.boxText
      }"
    >
      <!-- <VisibilityModal
        @close="closeWithNo()"
        @editVisibility="editVisibility"
        :box="box"
        v-if="visibilityModalVisible"
      /> -->
      <img class="box-image" :src="box.backgroundImage.replace('desktop', 'mobile').replace('desktop-1000', 'mobile-375')" :style="{opacity: bgImageTransparency }" v-if="box.showBgImage">
      <div class="wrapCenter">
        <div class="box-header">
          <div v-if="box.showIconImage && !box.showBgImage" class="iconImageBox">
            <img v-bind:src="box.iconImage" />
          </div>
          <v-icon
            v-else-if="box.showIcon && !box.showBgImage"
            class="iconBox"
            v-bind:color="box.iconColor"
            v-bind:name="box.icon"
            scale="3"
          ></v-icon>
          <div>
            <h4 
              class="box-title h4"
              :style="{ 
                color: box.boxText,
                ...customFont
              }"
            >
              {{ box.titles[languageTypesIndex] }}
            </h4>
          </div>
        </div>
        <div>
          <div 
            class="box-content"
            :style="{
              ...customFont
            }"
          >
            {{ box.texts[languageTypesIndex] }}
          </div>
          <div 
            class="box-content"
            :style="{
              ...customFont
            }"
          >
            {{ box.textsTwo[languageTypesIndex] }}
          </div>
        </div>
        <div v-if="box.showButton" class="box-footer">
          <div>
            <button
              v-if="box.page"
              v-bind:style="{
                backgroundColor: box.btncolor,
                color: box.btntext,
                ...customFont
              }"
              @click="routerPush(box.pageName, box.page)"
              class="gbBtn"
            >
              <span>{{ box.buttonTitles[languageTypesIndex] }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <transition name="fadeInModal">
      <standard-box-edit
        :pagesObject="pagesOverview"
        :box="box"
        :selectedBoxIndex="index"
        :completeBoxArray="boxes"
        :languageTypesIndex="languageTypesIndex"
        :style="{ zIndex: '99' }"
        @close="closeEditModal"
        v-if="showStandardEditModal"
      >
      </standard-box-edit>
    </transition>
    <transition name="fadeInModal">
      <confirm-modal
        @yes="closeWithYes()"
        @no="closeWithNo()"
        v-if="showConfirmModal"
      >
        <h2 slot="title">Delete Box?</h2>
        <p slot="description">The box and its content will be deleted</p>
      </confirm-modal>
    </transition>
  </section>
</template>

<script>
import FloatingActionButtons from "../../BoxesComponents/FloatingActionButtons";
import StandardBoxEdit from "./StandardBoxEdit";
import ConfirmModal from "@/components/GlobalComponents/ConfirmModal.vue";
// import VisibilityModal from "@/components/EditGuestbookPage/BoxesComponents/VisibilityModal.vue";
import bus from "@/bus.js";
import { db } from "@/firebase";
import config from "../../../../config";

export default {
  components: {
    FloatingActionButtons,
    StandardBoxEdit,
    ConfirmModal,
    // VisibilityModal,
  },
  props: {
    box: Object,
    index: Number,
    activeFABIndex: Number,
    boxes: Array,
    customFonts: Object,
    pagesOverview: Object,
    languageTypesIndex: Number,
  },
  data() {
    return {
      showStandardEditModal: false,
      showConfirmModal: false,
      visibilityModalVisible: false,
      visibilityEdited: false,
    };
  },
  computed: {
    customFont() {
      return this.customFonts.customFonts ? {'font-family': this.customFonts.customFontCss } : {};
    },
    bgImageTransparency() {
      return Number((this.box.bgTransparency ? this.box.bgTransparency : '100')) / 100;
    },
  },
  methods: {
    showDeleteModal() {
      this.showConfirmModal = true;
      this.$emit("toggleModal", true);
      bus.$emit("bodyOverflow", true);
    },
    showEditModal() {
      this.showStandardEditModal = true;
      this.$emit("toggleModal", true);
      bus.$emit("bodyOverflow", true);
    },
    showVisibilityModal() {
      this.visibilityModalVisible = true;
      this.visibilityEdited = false;
      this.$emit("toggleModal", true);
    },
    editVisibility(payload) {
      this.box.visibility = payload;
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/${this.index}`).set(this.box);
      this.visibilityEdited = true;
    },
    closeEditModal() {
      this.showStandardEditModal = false;
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    closeWithYes: function () {
      this.showConfirmModal = false;
      this.deleteBox(this.index);
      this.$toastEvents.push({
        type: "copy",
        title: "Deletion",
        content: "The box has been deleted!",
        id: +new Date(),
      });
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    closeWithNo: function () {
      if (this.showConfirmModal) {
        this.showConfirmModal = false;
      } else if (this.visibilityModalVisible) {
        this.visibilityModalVisible = false;
        if (this.visibilityEdited) {
          this.$toastEvents.push({
            type: "copy",
            title: "Visibility",
            content: "The visibility has been edited!",
            id: +new Date(),
          });
        }
      }
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    deleteBox(boxIndex) {
      var newObjToFirebase = this.boxes;
      newObjToFirebase.splice(boxIndex, 1);
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(newObjToFirebase);
    },
    routerPush: function (type, data) {
      
      if (type === "Costum-link") {
        let data = this.box.httpLinks[this.languageTypesIndex]
        if (!data.includes('http')) {
          data = 'https://' + data;
        }
        window.open(`${data}`, "_blank");        
      } else if (type === "file") {
        window.open(`${data}`, "_blank");
      } else if (type == "mobilePhone") {
        window.open(`tel:${data}`, "_self");
      } else if (type == "emailAddress") {
        window.open(`mailto:${data}`, "_self");
      } else {
        window.open(`${config.hardcodedPath}${data}`, "_blank");
      }
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

h4 {
  margin: 0px;
}

button {
  cursor: pointer;
}

.wrapCenter {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  z-index: 3;
}

.standard-box {
  height: 100%;
}

/* Create three equal columns that floats next to each other */
.column {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  padding-top: 12px;
  padding-bottom: 0px;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.box-image {
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  border-radius: 8px;
}

.removeTopPadding {
  padding-top: 0px;
}
.extraTopPadding {
  padding-top: 80px;
}
.iconBox {
  height: 70px;
  overflow: hidden;
  margin-top: 8px;
}

.iconImageBox {
  height: 70px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 5px;
}

.iconImageBox > img {
  max-height: 100%;
  max-width: 100%;
}

.box-title {
  margin-top: auto;
  margin-bottom: auto;
  min-height: 30px;
  display: flex;
  justify-content: center;
}

.box-title-custom {
  margin-top: 10px;
  margin-bottom: 5px;
  display: block;
  font-size: 2.5em;
  line-height: 1;
}

.box-content {
  margin: 0 auto;
  line-height: 1.3em;
}

.box-footer {
  margin-top: auto;
  border-radius: 8px;
  min-height: 58px;
}

.gbBtn {
  height: 45px;
  padding: 0px 9px;
  margin-bottom: 13px;
  border: 2px solid transparent;
  width: calc(100% - 26px);
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  overflow-x: hidden;
}
</style>
